require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./compliance-guide-0-11-0.json") })
        }
      }, "path---compliance-guide-0-11-0");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---compliance-guide-0-11-0!./.cache/json/compliance-guide-0-11-0.json
// module id = 378
// module chunks = 231608221292675